import { useEffect, type ReactNode } from "react";
import { ZoneProvider } from "@/contexts/ZoneContext";
import { IdentityProvider } from "@/contexts/IdentityContext";
import { WalletProvider } from "@/contexts/WalletContext";
import { ErrorBoundary, initGlobalErrorHandler } from "@/components/error-boundary";

export function Providers({ children }: { children: ReactNode }) {
  useEffect(() => {
    initGlobalErrorHandler();
  }, []);

  return (
    <ErrorBoundary>
      <ZoneProvider>
        <IdentityProvider>
          <WalletProvider>{children}</WalletProvider>
        </IdentityProvider>
      </ZoneProvider>
    </ErrorBoundary>
  );
}
